import React, { useState, useEffect, useRef } from "react";
import { ReactSVG } from "react-svg";
import FilterBig from "../../../src/components/FileRepo/Components/Filter";
import Filter from "./Filter";
import Sort from "./Sort";
import { search as srch } from "../../assets/images/images";
import { useDebounce } from "../FileRepo/hooks/useDebounce";

const SearchBar = ({ search, setSearch, filterArray, sortOption, setSortOption, filterOption, setfilterOption, filterSort = true, width = "w-full", contMargin = "", inputWidth = "w-[70%]", title, sortedInvitations, invitationsForFilter, handleApplyFilter, onResetFilter, setIsVisiblefillter, isVisiblefillter, placeholder="search" }) => {

  const [isVisible, setIsVisible] = useState(false);
  const [localSearch, setLocalSearch] = useState(search);
  const debouncedSearch = useDebounce(localSearch, 400);
  const sortWrapperRef = useRef(null); 

  useEffect(() => {
    setSearch(debouncedSearch);
  }, [debouncedSearch, setSearch]);

  useEffect(() => {
    setLocalSearch(search);
  }, [search]);

    useEffect(() => {
    const handleClickOutside = (event) => {
      if (sortWrapperRef.current && !sortWrapperRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    };

    if (isVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible]);


  const sortArray = [
    { id: "A-Z", name: "A-Z" },
    { id: "Z-A", name: "Z-A" },
    { id: "Newest", name: "Newest first" },
    { id: "Oldest", name: "Oldest First" },
  ]





  const handleSortOptionChange = (newSortOption) => {
    setSortOption(newSortOption);
  };

  return (
    <>
      <div className={`search_header-container ${width} ${contMargin}`}>
        {
          title === 'Invited Students' && (
            <p style={{ fontSize: "20px", fontWeight: "500", width: "250px" }}>Invited Students</p>
          )
        }
        <div className="relative w-full">
          <ReactSVG className="search-icon" src={srch} />
          <input type="text" className={`py-[10px] pr-[10px] pl-[49px] text-[13px] bg-white border-none rounded-[20px] shadow-[0px_0px_12px_0px_#0000001F] focus:!shadow-[0px_0px_16px_0px_#00000033] ${inputWidth}`} placeholder={placeholder} name="search" value={localSearch} onChange={(e) => setLocalSearch(e.target.value)} />
        </div>

        {filterSort &&
          <div className="filter-wrapper">
            <div className="lessonviewprogress-filder-tab"

            >
              <p onClick={() => {
                setIsVisiblefillter(!isVisiblefillter); setIsVisible(false);
              }}><i className="fa-solid fa-sliders" style={{ paddingRight: "10px" }}></i>Filter</p>
              {
                title === 'Invited Students'
                  ?
                  <FilterBig
                    open={isVisiblefillter}
                    close={() => setIsVisiblefillter(false)}
                    updatedOn={true}
                    fileType={false}
                    invitedBy={true}
                    sortedInvitations={invitationsForFilter ?? []}
                    appliedFilters={() => { }}
                    applyFilter={handleApplyFilter}
                    onReset={onResetFilter}
                  />
                  :
                  <Filter
                    filterArray={filterArray}
                    filterOption={filterOption}
                    setfilterOption={setfilterOption}
                    setIsVisiblefillter={setIsVisiblefillter}
                  />
              }

            </div>
            <div className="lessonviewprogress-filder-tab"
            ref={sortWrapperRef}
            >
              <p onClick={() => {
                setIsVisible(!isVisible); setIsVisiblefillter(false);
              }}><span>
                  <i class="fa-solid fa-arrow-down-wide-short"></i>
                </span>Sort</p>
              {isVisible && <Sort sortArray={sortArray} sortOption={sortOption} setSortOption={setSortOption} setIsVisible={setIsVisible} />}
            </div>
          </div>}
      </div>
    </>
  );
};

export default SearchBar;